import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import PropTypes from 'prop-types'
import naCodeMaintenanceAutocompleteField from './NaCodeDescCodeMaintainceAutoCompleteField'

function NaDangerousGoodsAutocompleteField(props) {
  return naCodeMaintenanceAutocompleteField(
    props,
    CodeMaintenanceType.DANGEROUS_GOODS
  )
}

export default NaDangerousGoodsAutocompleteField